import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchFilters } from '../services/organisationService';

export const FiltersContext = createContext();

export const FiltersProvider = ({ children }) => {
  const [cities, setCities] = useState([]);
  const [practiceAreas, setPracticeAreas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadFilters = async () => {
      try {
        const { cities: fetchedCities, practiceAreas: fetchedAreas } = await fetchFilters();
        setCities(fetchedCities);
        setPracticeAreas(fetchedAreas);
        setError(null);
      } catch (error) {
        console.error('Error loading filters:', error);
        setError('Failed to load filters');
      } finally {
        setLoading(false);
      }
    };

    loadFilters();
  }, []);

  return (
    <FiltersContext.Provider value={{ cities, practiceAreas, loading, error }}>
      {children}
    </FiltersContext.Provider>
  );
};

export const useFilters = () => {
  const context = useContext(FiltersContext);
  if (!context) {
    throw new Error('useFilters must be used within a FiltersProvider');
  }
  return context;
}; 